"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _taskList = _interopRequireDefault(require("./component/taskList.vue"));
var _taskAdd = _interopRequireDefault(require("./component/taskAdd.vue"));
var _reviewList = _interopRequireDefault(require("./component/reviewList.vue"));
var _postList = _interopRequireDefault(require("./component/postList.vue"));
var _trendSetter = _interopRequireDefault(require("./component/trendSetter.vue"));
var _trendSetterList = _interopRequireDefault(require("./component/trendSetterList.vue"));
var _taskLog = _interopRequireDefault(require("./component/taskLog.vue"));
var _postDetail = _interopRequireDefault(require("./component/postDetail.vue"));
var _blacklist = _interopRequireDefault(require("./component/blacklist.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '小红书',
  components: {
    blacklist: _blacklist.default,
    taskList: _taskList.default,
    taskAdd: _taskAdd.default,
    reviewList: _reviewList.default,
    trendSetter: _trendSetter.default,
    trendSetterList: _trendSetterList.default,
    taskLog: _taskLog.default,
    postList: _postList.default,
    postDetail: _postDetail.default
  },
  data: function data() {
    return {
      refresh: false,
      actTitle: null,
      actId: null,
      userId: null,
      loading: false,
      selectedPost: {},
      activeTab: 'taskList',
      tabs: ['taskList', 'reviewList']
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    detailUserLog: function detailUserLog(row) {
      this.userId = row;
      this.activeTab = 'taskLog';
    },
    RewardUserLog: function RewardUserLog(row) {},
    saved: function saved() {
      this.refresh = true;
      this.activeTab = 'taskList';
    },
    addAct: function addAct() {
      this.actId = null; // 新增时清空
      this.activeTab = 'taskAdd';
    },
    handleEdit: function handleEdit(row) {
      this.activeTab = 'taskAdd';
      this.actId = row.id;
    },
    handleCopy: function handleCopy(row) {
      this.activeTab = 'taskAdd';
      this.actId = row.id + '_copy';
    },
    postList: function postList(row) {
      // this.activeTab = 'expandList';
      // this.actTitle = row.activityName;
      this.actId = row.id;
      this.activeTab = 'postList';
    },
    reviewList: function reviewList(row) {
      this.actTitle = row.activityName;
      this.actId = row.id;
      this.activeTab = 'reviewList';
    },
    handleTabChange: function handleTabChange(tab) {
      this.actId = null;
      this.activeTab = tab.name;
    },
    showPostDetail: function showPostDetail(row) {
      this.selectedPost = row || {};
      this.activeTab = 'postDetail';
    },
    removeTab: function removeTab(tabName) {
      // const index = this.tabs.indexOf(tabName)
      // if (index !== -1) this.tabs.splice(index, 1)
      // if (this.activeTab === tabName) {
      //     this.activeTab = 'taskList'
      // }
    }
  },
  mounted: function mounted() {}
};